define(['components/utilities/utilities'], function (utils) {
	'use strict';

	/**
	 * checkboxRequiredGroup
	 * A plugin that adds validation to a group of checkboxes there one or more must be checked.
	 * @version 1.0.0
	 * @exports checkboxRequiredGroup
	 */
	var checkboxRequiredGroup = {

		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			this._initCheckboxRequiredGroup();
		},


		/**
		 * Function that initiates the checkbox group required functionality.
		 * @private
		 */
		_initCheckboxRequiredGroup: function () {
			var that = this;

			utils.forEachElement('[data-type="checkbox-required-group"]', function (el) {
				if (el.getAttribute('data-checkbox-required-group-initiated') !== null) {
					return false;
				}
				el.setAttribute('data-checkbox-required-group-initiated', true);

				var checkboxes = el.querySelectorAll('input[type="checkbox"]');

				utils.forEach(checkboxes, function (checkbox) {
					utils.addEventListener(checkbox, 'change', function () {
						that._setCheckboxesRequired(el);
					});
				});
				that._setCheckboxesRequired(el);
			});
		},



		/**
		 * Check all checkboxes and see if any is checked.
		 * If non is checked all will be marked as required with a custom validation message.
		 * @private
		 */
		_setCheckboxesRequired: function (el) {
			var anySelected = el.querySelectorAll('input[type="checkbox"]:checked').length > 0,
				checkboxes = el.querySelectorAll('input[type="checkbox"]');

			if (!anySelected) {
				utils.forEach(checkboxes, function (checkbox) {
					checkbox.setCustomValidity('En eller flera kryssrutor måste markeras.');
					checkbox.setAttribute('required', true);
				});
			} else {
				utils.forEach(checkboxes, function (checkbox) {
					checkbox.setCustomValidity('');
					checkbox.removeAttribute('required');
				});
			}
		}
	};


	return checkboxRequiredGroup;
});



//////////////////
// WEBPACK FOOTER
// ./components/checkboxRequiredGroup/checkboxRequiredGroup.js
// module id = 9
// module chunks = 0